import { render, staticRenderFns } from "./categorias.vue?vue&type=template&id=2a6daef0&scoped=true&"
import script from "./categorias.vue?vue&type=script&lang=js&"
export * from "./categorias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6daef0",
  null
  
)

export default component.exports